/*@ngInject*/
module.exports = function() {
	return {
		scope: {
			images: '<',
			objectName: '<',
			objectDescription: '<',
		},
        bindToController: true,
        controllerAs: 'vm',
        controller: function() {
			let vm = this;
			vm.openGalery = function(id) {
				const element = document.getElementById('link_' + id);
				element.click();
			};

			// add focus class on a focused image
			vm.setFocus = function(id, event) {
				console.log(event);
				// const element = document.getElementById('link_' + id).closest('.detail-car-nav__item');
				// element.classList.add('focused-element');
			};

			// remove focus class from unfocused image
			vm.blur = function(id, event) {
				console.log(event);
				// const element = document.getElementById('link_' + id).closest('.detail-car-nav__item');
				// element.classList.remove('focused-element');
			};

			// enable slick elements to click on magnific-popup when entered into
			function handleKeydown(event) {
				if (event.keyCode === 13 && event.target.classList.value.includes('slick-slide')) { // tab key
					let imageIndex = event.target.getAttribute('data-slick-index');
					vm.openGalery(vm.images[imageIndex].id);
				}
			}

			document.addEventListener('keydown', handleKeydown);
			const timeout = window.setTimeout;
			// Manage slick track tabindex logic
			timeout(() => {
				const slickTrack = document.querySelector('.detail-car-nav');
				if (!slickTrack) {
					return;
				}

				let monitoring = true;

				function updateTabindex(value) {
					const slides = slickTrack.querySelectorAll('.slick-slide');
					slides.forEach(slide => {
						slide.setAttribute('tabindex', value);
						slide.setAttribute('aria-hidden', value === 0 ? 'false' : 'true');
					});
				}

				function onFocusIn(event) {
					if (monitoring && slickTrack.contains(event.target)) {
						timeout(() => updateTabindex(0), 0);
						monitoring = false;
					
					}
				}

				function onFocusOut() {
					if (!slickTrack.contains(document.activeElement)) {
						monitoring = true;
					}
				}

				slickTrack.addEventListener('focusin', onFocusIn);
				slickTrack.addEventListener('focusout', onFocusOut);
			}, 1000);

		},

		template: require('./object-images.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-images.directive.js
 **/